const QueryConstants = {
  ADD_A_FEED: 'addAFeed',
  MARKETING_PATH: 'mktPath',
  POSTING_PATH: 'postingPath',
  SECURITY_TOKEN: 'securityToken',
  SIGN_IN_LP: 'signInLP',
  HAS_SUCCESS_REDIRECT_PATH: 'hasSuccessRedirectPath',
  CLAIM_DASHBOARD: 'claimDashboard',
  REDIRECT_TO: 'redirectTo',
  SUB_NAV_FILTER_TYPE: 'subNavFilterType',
  SEARCH_TEXT: 'searchText',
  SCROLL_TO: 'scrollTo',
};

export default QueryConstants;
